import { Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, styled, useTheme, } from '@mui/material';
import { H4, Label1, Label2 } from '../../atoms/typography';
const PageHeaderContainer = styled(Box) `
  display: flex;
`;
const StepNumber = styled('div', {
    shouldForwardProp: prop => prop !== 'moduleColor',
}) `
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 100px;
  background-color: ${({ moduleColor, theme }) => moduleColor || theme.palette.modules?.default || theme.palette.primary.main};
  height: 32px;
  width: 32px;
  margin-right: 16px;
  margin-top: 5px;
  & > p {
    transform: translate(0, 25%);
  }
`;
const PageHeader = ({ instructionText = '', headerText, stepNumber, children, moduleName, sx, }) => {
    const theme = useTheme();
    const moduleColor = moduleName && theme.palette.modules[moduleName];
    const instructionElement = children ? (_jsx(_Fragment, { children: children })) : (_jsx(Label1, { color: "text.secondary", children: instructionText }));
    return (_jsxs(PageHeaderContainer, { sx: sx, children: [stepNumber ? (_jsx(StepNumber, { moduleColor: moduleColor, children: _jsx(Label2, { color: "common.white", children: stepNumber }) })) : null, _jsxs("div", { children: [_jsx(H4, { children: headerText }), instructionElement] })] }));
};
export default PageHeader;
//# sourceMappingURL=index.js.map